import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';
import { authHeader } from "../../../javascript/auth-header";

export const exportVendorChart = (chartDiv, chartName, display_id, currentDateTime, university, year, report_vintage_vendor) => {
    //console.log("lala");
    exportVendorReportImage(chartDiv, chartName, display_id, currentDateTime, university, year, report_vintage_vendor);
}

export async function deleteVendorReportImage(fileName, state, props) {
    var currentDateTime = state.currentDateTime;
    var display_id = props.UserState.report_display_id;

    let url = "/webapi/NewVendorReport/delete_image";

    var obj = {};

    obj["display_id"] = display_id;
    obj["currentDateTime"] = currentDateTime;
    obj["imageName"] = fileName;

    var headers = authHeader();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
}


export const exportVendorReportImage = (
    divName,
    imageName,
    report_display_id,
    currentDateTime,
    university,
    year,
    report_vintage_vendor
) => {
    html2canvas(document.querySelector(divName)).then(canvas => {
        //var a = document.createElement('a');
        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            const blob = new Blob(byteArrays, { type: contentType });
            return blob;
        }

        let dataURL = canvas.toDataURL("image/png");
        const blob = b64toBlob(dataURL.substring(22), "image/png");

        let form = new FormData();
        form.append('image', blob, imageName);
        form.append("display_id", report_display_id);
        form.append("currentDateTime", currentDateTime);
        form.append("vintage", report_vintage_vendor);
        form.append("university", university);
        form.append("year", year);


        let url = "/webapi/NewVendorReport/send_image";


        fetch(url, { method: 'POST', body: form }).then(res => {
            return res.blob();
        })
            .then(blob => {
                saveAs(blob, imageName);
            }).catch((error) => {
                console.log(error);
            })
    })


}

export async function saveVendorReportImage(div, index, fileName, controller, state, props) {
    console.log(props);
    var element = document.getElementsByClassName(div)[index];
    var currentDateTime = state.currentDateTime;
    var display_id = props.UserState.report_display_id;
    var university = props.NewEmployeeReportState.EmployeeProfileInfo.university;
    var year = props.NewVendorReportState.TrendsPar[0].max_year;
    //var end_year = props.NewEmployeeReportState.EmployeeMethodology.end_year;

    await html2canvas(element as HTMLCanvasElement).then(function (canvas) {
        canvas.toBlob(function (blob) {
            let url = "/webapi/NewVendorReport/send_image";
            //let url = "/webapi/" + controller + "/send_image/";
            let form = new FormData();
            form.append('image', blob, fileName);
            form.append("display_id", display_id);
            form.append("currentDateTime", currentDateTime);
            form.append("vintage", props.UserState.report_vintage_vendor);

            form.append("university", university);
            form.append("year", year);
            //form.append("end_year", "not needed");

            var headers = authHeader();

            fetch(url, { method: 'POST', body: form, headers: headers  })
        });
    });
}
